var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgMz = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 322.783h512v103.88H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#496e2d",
  d: "M0 85.337h512v104.515H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 210.877h512v89.656H0z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M256 256.006L0 426.668V85.331z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M83.477 195.132l15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M39.268 256h88.42v40.578h-88.42z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M144.443 209.479l-14.347-14.347-46.618 46.618-46.617-46.618-14.347 14.347 46.658 46.577-46.658 46.658 14.347 14.154 46.617-46.534 46.618 46.534 14.347-14.154-46.659-46.658z"
})));

export default SvgMz;